// extracted by mini-css-extract-plugin
export default {"integrations":"IntegrationsContent_integrations__5fV5e"};